export default __webpack_public_path__ + "static/media/cpv_37_music-sport-games-handwork-art.8ea18ffd.svg";